/**
 * CustText.tsx — Renders text content (`sectionData.text`) through the full
 * CMS text-directive pipeline.
 *
 * JSON trigger: `uiCompType.method: "renderCustText"`
 * Also invoked via the `renderText` helper in `index.tsx`.
 *
 * **Key options:**
 *  - `options.variant`      — MUI Typography variant forwarded to `transformDescription`
 *  - `options.markdown`     — Force Markdown processing
 *  - `options.gutterBottom` — Add bottom margin
 *  - `options.noWrap`       — Disable text wrapping
 *
 * **Mobile:** `uiCompType.mStyles` overrides `styles` when `deviceType === 'Mobile'`.
 *
 * **Style slots:** `uiCompType.styles`/`mStyles`, `uiCompType.className`.
 *
 * Delegates text rendering to `transformDescription` → `transformTextToHtml` →
 * `transformMarkdown`.
 */
import React, { useEffect, useState } from "react";
import { transformDescription } from "./shared";
import { SectionData, ComponentRenderProps } from "./index";
import { useDeviceType } from "@/hooks/useDeviceType";

interface CustTextProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CustText = ({ sectionData, props }: CustTextProps): JSX.Element | null => {
    const componentTag = sectionData.uiCompType?.options?.component || sectionData.uiCompType?.options?.variant || 'p';
    //TODO: Add support for mobile
    const deviceType = useDeviceType();
    const styles = sectionData.uiCompType?.styles || {};
    // const [styles, setStyles] = useState(sectionData.uiCompType?.styles || {});
    // useEffect(() => {
    //     if (deviceType === "Mobile" && sectionData.uiCompType?.mStyles) {
    //         setStyles({ ...sectionData.uiCompType?.styles, ...sectionData.uiCompType?.mStyles });
    //     }
    // }, [deviceType, sectionData.uiCompType]);
    return (
        <>
            {sectionData.text &&
                transformDescription(sectionData.text || '',
                    sectionData.uiCompType?.className,
                    (sectionData.trackId),
                    styles,
                    componentTag,
                    props, deviceType)
            }
        </>
    );
}
export default CustText;
